export const TEST_ID = 'toggleSlider';
